import { createSelector } from '@ngrx/store';
import { UserPreferenceReducer, UserPreferenceState } from '../reducer/user-preference.reducer';
import { UserPreferenceEnum } from '@shared/enums/common-data/user-preference.enum';

const inbondLayoutPreferences = createSelector(
  UserPreferenceReducer.userPreferenceFeatureSelector,
  (state: UserPreferenceState) => state[UserPreferenceEnum.inbondLayout]
);

const redeliveryLayoutPreferences = createSelector(
  UserPreferenceReducer.userPreferenceFeatureSelector,
  (state: UserPreferenceState) => state[UserPreferenceEnum.redeliveryLayout]
);

export const UserPreferenceSelectors = { inbondLayoutPreferences, redeliveryLayoutPreferences };
